import React, { useState } from 'react';
import classNames from 'classnames';

const styles = require('./SmallProfileDisplayItem.module.scss');

export interface DisplayProps {
  color?: string;
  header?: string | JSX.Element;
  label?: string | JSX.Element;
  title: string;
}

export default function SmallProfileDisplayItem(props: DisplayProps) {
  const { header, title, label } = props;

  const color = props.color || 'tuftsBlue';
  const titleStyleArray = [styles.title, styles[color]];
  const titleStyle = classNames(...titleStyleArray);

  return (
    <div className={styles.skillItem}>
      {header}
      <div className={titleStyle}>{title}</div>
      {label && <div className={styles.label}>{label}</div>}
    </div>
  );
}
